'use client';

import { PropsWithChildren, useMemo } from 'react';
import clsx from 'clsx';
import { useFormStatus } from 'react-dom';

export type SubmitButtonProps = PropsWithChildren<{
  id?: string;
  className?: string;
  disabled?: boolean;
  formAction?: string | ((formData: FormData) => void);
  style?: React.CSSProperties;
  suppressHydrationWarning?: boolean;
}>;

export function SubmitButton({
  id,
  className,
  disabled = false,
  children,
  style,
  formAction,
  ...restProps
}: SubmitButtonProps) {
  const { pending } = useFormStatus();

  const inactive = useMemo(() => {
    return pending || disabled;
  }, [pending, disabled]);

  return (
    <button
      id={id}
      style={style}
      formAction={formAction}
      className={clsx('relative transition-all', className)}
      type="submit"
      disabled={inactive}
      aria-disabled={inactive}
      {...restProps}
    >
      {pending && (
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="loading loading-spinner" />
        </div>
      )}
      <span className={clsx('transition-all', pending ? 'opacity-0' : 'opacity-100')}>
        {children}
      </span>
    </button>
  );
}
